import classNames from "classnames";

import { formatPrice } from "@jti/format-price";

import styles from "./FormattedPrice.module.scss";

export type FormattedPriceProps = {
  className?: string;
  locale?: string;
  value: number;
  currency: string;
  currencyDisplay?: "symbol" | "code";
  format?: string;
};

export const FormattedPrice: React.FC<FormattedPriceProps> = ({
  className,
  locale,
  value,
  currency,
  currencyDisplay,
  format,
}) => {
  return (
    <span className={classNames(styles.price, className)}>
      {formatPrice({ locale, value, currency, currencyDisplay, format })}
    </span>
  );
};
